import 'luxon';

declare global {
    interface Number {
        paraListaNumerica(): Array<{ valor?: number | string, rotulo: string }>;
        moeda(): string;
    }
}

Number.prototype.paraListaNumerica = function()
{
    const lista: Array<{
        valor?: number | string,
        rotulo: string
    }> = [];

    Array.from(Array(this), (x,i) => {
        const valor = i + 1;

        lista.push({ valor, rotulo: valor.toString() });
    });

    return lista;
}

Number.prototype.moeda = function()
{
    return `R$: ${this.toFixed(2)}`;
}
